import store from '../q-store'

export const logout = (sessionId, next) => {

  // caller.delegate('qasedak', 'Logout', {sessionId}).then((res) => {
  store.commit('closeSession');
  next('/login');
  // }).catch(() => {
  // });
};

export const loggedIn = () => {
  try {
    let userSession = store.state.session;

    if (userSession === undefined)
      return false;
    if (userSession === null)
      return false;
    if (userSession.sessionId === "GUEST")
      return false;

  } catch {
    return false;
  }

  return true;
};

export const authorize = function (to) {
  if(to === '')
    console.log('authorize i q-user');

  return true;//AMIN
};

export default { logout, loggedIn, authorize };
